import _defineProperty from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["style", "width", "height", "titleText", "captionText", "linkText", "linkIcon", "LinkComponent", "link", "hasButton", "comingSoon", "labelText", "highlightColor", "isMobile", "titleClassname", "superBigAnimated", "onClick", "color", "textIcon", "textIconWidth"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React__default, { Fragment } from 'react';
import styled from 'styled-components';
import '../../App.css.js';
import { parseIcon, parseColor } from '../../utils/utils.js';
import Action from '../actions/action.component.js';
import AnimationWrapper from '../animation/animation-wrapper.component.js';
import Text from '../text/text.component.js';
var Div = styled.div.withConfig({
  displayName: "block-description-big-oldcomponent__Div",
  componentId: "sc-zx5yhm-0"
})(["padding-top:96px;padding-bottom:96px;margin-left:auto;margin-right:auto;a{text-decoration:none !important;}span:not(.labelText){font-family:inherit !important;}.margin-top-superbig-paragraph{margin-top:34px;}.margin-top-last-text-paragraph{margin-top:48px;}@media screen and (max-width:768px){padding-top:48px;padding-bottom:48px;.margin-top-superbig-paragraph{margin-top:24px;}.margin-top-last-text-paragraph{margin-top:24px;}}.link{.link-icon{transition:0.2s;transform:translateX(0px);}&:hover{.link-icon{transition:0.2s;transform:translateX(4px);}}}"]);
var TextLinkXLarge = styled(Text).withConfig({
  displayName: "block-description-big-oldcomponent__TextLinkXLarge",
  componentId: "sc-zx5yhm-1"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Bold,Arial;font-weight:700;font-size:16px;line-height:20px;}"]);
var TextTitleBig = styled(Text).withConfig({
  displayName: "block-description-big-oldcomponent__TextTitleBig",
  componentId: "sc-zx5yhm-2"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Bold,Arial;font-weight:700;font-size:48px;line-height:57px;}"]);
var TextDescriptionBig = styled(Text).withConfig({
  displayName: "block-description-big-oldcomponent__TextDescriptionBig",
  componentId: "sc-zx5yhm-3"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Medium,Arial;font-weight:500;font-size:20x;line-height:26px;}"]);
var BlockDescriptionBig = function BlockDescriptionBig(_ref) {
  var style = _ref.style,
    width = _ref.width,
    height = _ref.height,
    titleText = _ref.titleText,
    captionText = _ref.captionText,
    linkText = _ref.linkText,
    linkIcon = _ref.linkIcon,
    LinkComponent = _ref.LinkComponent,
    link = _ref.link,
    hasButton = _ref.hasButton,
    comingSoon = _ref.comingSoon,
    labelText = _ref.labelText,
    highlightColor = _ref.highlightColor,
    isMobile = _ref.isMobile,
    titleClassname = _ref.titleClassname,
    superBigAnimated = _ref.superBigAnimated,
    onClick = _ref.onClick,
    color = _ref.color,
    textIcon = _ref.textIcon,
    textIconWidth = _ref.textIconWidth,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Div, {
    style: _objectSpread({
      width: width,
      height: height,
      display: "flex",
      flexDirection: "column"
    }, style)
  }, /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(AnimationWrapper, {
    fadeIn: !isMobile ? true : false,
    fadeInDistance: "20px",
    fadeInDuration: "0.8s",
    fadeInOffset: 100,
    scrollElement: typeof window != "undefined" ? document : null
  }, textIcon ? /*#__PURE__*/React__default.createElement(TextTitleBig, {
    className: titleClassname,
    fontFamily: "euclid",
    type: "display",
    fontSize: "large",
    tag: "h2",
    style: {
      marginBottom: "0px"
    }
  }, parseIcon(titleText, textIcon, textIconWidth)) : /*#__PURE__*/React__default.createElement(TextTitleBig, {
    className: titleClassname,
    fontFamily: "euclid",
    type: "display",
    fontSize: "large",
    tag: "h2",
    style: {
      marginBottom: "0px"
    }
  }, parseColor(titleText, highlightColor))), captionText ? /*#__PURE__*/React__default.createElement(AnimationWrapper, {
    fadeIn: !isMobile ? true : false,
    fadeInDistance: "20px",
    fadeInDuration: "0.8s",
    fadeInOffset: 100,
    scrollElement: typeof window != "undefined" ? document : null
  }, /*#__PURE__*/React__default.createElement(TextDescriptionBig, {
    fontFamily: "euclid",
    type: "heading",
    fontSize: "mediumM",
    tag: "p",
    color: "grey-1",
    style: {
      marginTop: "24px",
      marginBottom: "0px"
    }
  }, captionText)) : null, link ? /*#__PURE__*/React__default.createElement(AnimationWrapper, {
    fadeIn: !isMobile ? true : false,
    fadeInDistance: "20px",
    fadeInDuration: "0.8s",
    fadeInOffset: 100,
    scrollElement: typeof window != "undefined" ? document : null
  }, /*#__PURE__*/React__default.createElement(Action, {
    className: "margin-top-last-text-paragraph link",
    linkText: linkText,
    color: "green",
    active: true,
    linkIcon: linkIcon,
    link: link,
    LinkComponent: LinkComponent,
    forceHover: false,
    onClick: onClick,
    moveIcon: true
  })) : comingSoon ? /*#__PURE__*/React__default.createElement(TextLinkXLarge, {
    fontFamily: "euclid",
    type: "heading",
    fontSize: "medium",
    tag: "p",
    color: "var(--dark-gray-2)",
    style: {
      marginTop: "0px",
      marginBottom: "0px"
    }
  }, "Coming Soon") : null));
};
export { BlockDescriptionBig as default };